import { StoreAction, XmAction } from 'store/actions';

import { DeviceEsimTransfer } from './models';

export function deviceEsimTransferReducer(state: DeviceEsimTransfer, action: XmAction<DeviceEsimTransfer>): DeviceEsimTransfer {
    switch (action.type) {
        case StoreAction.POST_DEVICE_ESIM_TRANSFER:
            return action.payload;
        default:
            return state;
    }
}
